import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunSvcDiscountPrice, deleteBairunSvcDiscountPriceByIds, updateBairunSvcDiscountPrice, findBairunSvcDiscountPrice, getBairunSvcDiscountPriceList } from '@/api/bairun/svcDiscountPrice'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getSvcGroupList } from '@/api/bairun/svcGroup'; //  此处请自行替换地址

import SvcBalanceRangeComponent from './svcBalanceRangeComponent';
import couponSelect from '@/components/couponSelect/couponSelect';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

var _ruleTypeId = 10001;
export default {
  name: 'SvcDiscountGroupBase',
  components: {
    SvcBalanceRangeComponent: SvcBalanceRangeComponent,
    couponSelect: couponSelect,
    SearchTerm: SearchTerm
  },
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, format || 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    },
    getStationName: function getStationName(id) {
      var _this$allStationMap$S;

      return (_this$allStationMap$S = _this.allStationMap[String(id)]) === null || _this$allStationMap$S === void 0 ? void 0 : _this$allStationMap$S.stationName;
    },
    getSvcGroupName: function getSvcGroupName(id) {
      for (var i = 0; i < _this.svcGroupOptions.length; i++) {
        if (_this.svcGroupOptions[i].groupId === id) {
          return _this.svcGroupOptions[i].groupName;
        }
      }

      return '';
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      oilCodes = oilCodes + '';
      var oilCodeArr = oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    },
    getWeekNames: function getWeekNames(cycleDays) {
      cycleDays = cycleDays + '';
      var arr = cycleDays.split(',');
      var names = '';

      if (arr.length === 0 || arr.length === _this.weekOptions.length) {
        return '不限';
      }

      _this.weekOptions.map(function (o) {
        if (arr.includes(o.value + '')) {
          names += o.label + ',';
        }
      });

      return names.substr(0, names.length - 1);
    },
    getLeastOilMassNames: function getLeastOilMassNames(oilMass) {
      return oilMass === 0 ? '不限' : oilMass;
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getBairunSvcDiscountPriceList,
      searchInfo: {
        // 按配置顺序显示
        'stationId': '',
        'oilCode': '',
        'groupId': ''
      },
      loading: false,
      addVisible: false,
      updateVisible: false,
      viewVisible: false,
      type: '',
      dateRangeValueArr: [],
      multipleSelection: [],
      svcGroupOptions: [],
      weekOptions: [],
      weekCheckAll: false,
      weekChecked: [],
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      stationIdChecked: [],
      formData: {},
      timeRangeValueArr: ['00:00:00', '23:59:59'],
      couponFormData: {
        goodsType: '',
        dialogVisible: false,
        sellerId: '',
        selection: [],
        // 回显，如果有数据，组件默认勾选
        activityGoodsMoney: '0'
      },
      preStartDatePickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        stationIdString: [{
          required: true,
          message: '请选择油站',
          trigger: 'blur'
        }],
        oilCodeString: [{
          required: true,
          message: '请选择油品',
          trigger: 'blur'
        }],
        leastOilMass: [{
          required: true,
          message: '请输入限制升数',
          trigger: 'blur'
        }],
        isAddTicket: [{
          required: true,
          message: '请选择券限制',
          trigger: 'blur'
        }],
        groupId: [{
          required: true,
          message: '请选择卡群组',
          trigger: 'blur'
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择时间范围'));
            } else {
              callback();
            }
          }
        }],
        // weekChecked: [{
        //   required: true,
        //   trigger: 'blur',
        //   validator: (rule, value, callback) => {debugger
        //     if (!_this.weekChecked || _this.weekChecked.length <= 0) {
        //       callback(new Error('请选择每周时间'))
        //     } else {
        //       callback()
        //     }
        //   }
        // }
        // ],
        timeRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (!_this.timeRangeValueArr || _this.timeRangeValueArr.length !== 2) {
              callback(new Error('请选择每天时间'));
            } else {
              callback();
            }
          }
        }]
      },
      updateRules: {
        discount: [{
          type: 'number',
          required: true,
          message: '请输入单升优惠，金额必须大于等于0',
          trigger: 'blur',
          min: 0
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择时间范围'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])), {}, {
    // eslint-disable-next-line vue/return-in-computed-property
    getRule: function getRule() {
      switch (this.type) {
        case 'create':
          return this.rules;

        case 'update':
          return this.updateRules;

        default:
          break;
      }
    }
  }),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var svcGroupOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getDict('oilCode');

              case 2:
                _this3.oilCodesOptions = _context3.sent;
                _context3.next = 5;
                return _this3.getDict('week');

              case 5:
                _this3.weekOptions = _context3.sent;
                _context3.next = 8;
                return getSvcGroupList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 8:
                svcGroupOptions = _context3.sent;
                _this3.svcGroupOptions = svcGroupOptions.data.list.filter(function (item) {
                  return item.groupId > 0;
                });
                _this3.searchInfo.ruleTypeId = _ruleTypeId;
                _this3.formData = _this3.initData();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      return {
        ruleTypeId: _ruleTypeId,
        stationId: 0,
        stationIdString: null,
        oilCode: 9999,
        oilCodeString: null,
        discount: 0,
        balanceMin: 0,
        balanceMax: 0,
        dateStart: '',
        dateEnd: '',
        sysUserId: 0,
        sysUserName: '',
        priceArr: [],
        groupId: '',
        discountTitle: '',
        leastOilMass: 0,
        timeStart: '',
        timeEnd: '',
        cycleDays: '',
        isAddTicket: 1,
        discountPriceTicketList: []
      };
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.searchInfo.ruleTypeId = _ruleTypeId;
                _this4.loading = true;

                _this4.getTableData();

                _this4.loading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onClose: function onClose() {
      this.addVisible = false;
      this.updateVisible = false;
      this.viewVisible = false;
      this.timeRangeValueArr = ['00:00:00', '23:59:59'];
      this.weekChecked = [];
      this.weekCheckAll = false;
      this.stationIdChecked = [];
      this.oilCodesChecked = [];
      this.oilCodesCheckAll = false;
      this.formData = this.initData();

      if (this.$refs.SvcBalanceRangeComponent) {
        this.$refs.SvcBalanceRangeComponent.init();
      }
    },
    // 添加优惠券
    onAddTicket: function onAddTicket() {
      this.couponFormData.dialogVisible = true;
    },
    // 删除优惠券
    onDelActivityTicket: function onDelActivityTicket(row) {
      debugger;
      var that = this;
      that.formData.discountPriceTicketList = that.formData.discountPriceTicketList.filter(function (item) {
        return item.ticketRuleNo != row.ticketRuleNo;
      });
    },
    // 选择优惠券-确定
    ticketSelDialogOk: function ticketSelDialogOk(res) {
      var that = this;
      that.couponFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          var isExit = false;
          that.formData.discountPriceTicketList.forEach(function (item2) {
            if (item2.ticketRuleNo == item.ticketRuleNo) {
              isExit = true;
            }
          });

          if (!isExit) {
            that.formData.discountPriceTicketList.push(JSON.parse(JSON.stringify(item)));
          }
        });
      }
    },
    // 选择优惠券-关闭
    ticketDialogClose: function ticketDialogClose() {
      this.couponFormData.dialogVisible = false;
    },
    onView: function onView() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;

                if (!(that.multipleSelection.length === 0)) {
                  _context5.next = 4;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });
                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return findBairunSvcDiscountPrice({
                  ID: that.multipleSelection[0].ID
                });

              case 6:
                res = _context5.sent;

                if (res.code === 0) {
                  that.formData = res.data.resBairunSvcDiscountPrice;
                  that.weekChecked = that.formData.cycleDays === '' ? [] : that.formData.cycleDays.split(',').map(Number);
                  that.weekCheckAll = that.weekChecked.length === that.weekOptions.length;
                  that.oilCodesChecked[0] = that.formData.oilCode;
                  that.oilCodesCheckAll = that.oilCodesChecked.length === that.oilCodesOptions.length; // eslint-disable-next-line eqeqeq

                  that.formData.groupId = that.formData.groupId == 0 ? '' : that.formData.groupId; //不能用以下写法，回显会不展示
                  // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
                  // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

                  that.formData.dateStart = that.$options.filters.formatDate(that.formData.dateStart);
                  that.formData.dateEnd = that.$options.filters.formatDate(that.formData.dateEnd);
                  that.timeRangeValueArr = [that.formData.timeStart, that.formData.timeEnd];
                  that.dateRangeValueArr = [that.formData.dateStart, that.formData.dateEnd];
                  that.type = 'view';
                  that.viewVisible = true;
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onAdd: function onAdd() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.type = 'create';
                _this6.addVisible = true;

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onUpdate: function onUpdate() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;

                if (!(that.multipleSelection.length === 0)) {
                  _context7.next = 4;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });
                return _context7.abrupt("return");

              case 4:
                if (!(that.multipleSelection.length > 1)) {
                  _context7.next = 7;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: '只能选择一条数据'
                });
                return _context7.abrupt("return");

              case 7:
                _context7.next = 9;
                return findBairunSvcDiscountPrice({
                  ID: that.multipleSelection[0].ID
                });

              case 9:
                res = _context7.sent;

                if (res.code === 0) {
                  that.formData = res.data.resBairunSvcDiscountPrice;
                  that.oilCodesChecked[0] = that.formData.oilCode;
                  that.oilCodesCheckAll = that.oilCodesChecked.length === that.oilCodesOptions.length;
                  that.weekChecked = that.formData.cycleDays === '' ? [] : that.formData.cycleDays.split(',').map(Number);
                  that.weekCheckAll = that.weekChecked.length === that.weekOptions.length; // eslint-disable-next-line eqeqeq

                  that.formData.groupId = that.formData.groupId == 0 ? '' : that.formData.groupId; //不能用以下写法，回显会不展示
                  // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
                  // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

                  that.formData.dateStart = that.$options.filters.formatDate(that.formData.dateStart);
                  that.formData.dateEnd = that.$options.filters.formatDate(that.formData.dateEnd);
                  that.dateRangeValueArr = [that.formData.dateStart, that.formData.dateEnd];
                  that.timeRangeValueArr = [that.formData.timeStart, that.formData.timeEnd];
                  that.type = 'update';
                  that.updateVisible = true;

                  if (!that.formData.discountPriceTicketList) {
                    that.formData.discountPriceTicketList = [];
                  }
                }

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onBatchDelete: function onBatchDelete() {
      var _this8 = this;

      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择要操作的数据'
        });
        return;
      }

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.handleDeletes();
      }).catch(function (err) {});
    },
    onDialogSubmit: function onDialogSubmit() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var that, discountPriceTicketList, subFormValid;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this9;
                discountPriceTicketList = []; // 优惠券

                that.formData.cycleDays = that.weekChecked.join(',');
                that.formData.dateStart = that.dateRangeValueArr[0];
                that.formData.dateEnd = that.dateRangeValueArr[1];
                that.formData.timeStart = that.timeRangeValueArr[0];
                that.formData.timeEnd = that.timeRangeValueArr[1];
                _context8.t0 = _this9.type;
                _context8.next = _context8.t0 === 'create' ? 10 : _context8.t0 === 'update' ? 22 : 29;
                break;

              case 10:
                if (_this9.checkParam()) {
                  _context8.next = 12;
                  break;
                }

                return _context8.abrupt("return");

              case 12:
                that.formData.stationIdString = that.stationIdChecked.join(',');
                that.formData.oilCodeString = that.oilCodesChecked.join(',');
                that.formData.priceArr = JSON.stringify(that.$refs.SvcBalanceRangeComponent.formData.priceArr); // eslint-disable-next-line eqeqeq

                that.formData.dateStart = that.dateRangeValueArr[0];
                that.formData.dateEnd = that.dateRangeValueArr[1];
                subFormValid = that.$refs.SvcBalanceRangeComponent.validateForm();
                that.formData.discountPriceTicketList.forEach(function (item) {
                  discountPriceTicketList.push({
                    'ticketRuleNo': item.ticketRuleNo
                  });
                });
                that.formData.discountPriceTicketList = discountPriceTicketList;
                that.$refs['formData'].validate(function (valid) {
                  if (!subFormValid || !valid) {
                    return;
                  }

                  createBairunSvcDiscountPrice(that.formData).then(function (res) {
                    that.enterDialogRepose(res);
                  });
                });
                return _context8.abrupt("break", 30);

              case 22:
                if (_this9.checkParam()) {
                  _context8.next = 24;
                  break;
                }

                return _context8.abrupt("return");

              case 24:
                that.formData.dateStart = that.dateRangeValueArr[0];
                that.formData.dateEnd = that.dateRangeValueArr[1];

                if (that.formData.isAddTicket == 3) {
                  that.formData.discountPriceTicketList.forEach(function (item) {
                    discountPriceTicketList.push({
                      'ticketRuleNo': item.ticketRuleNo
                    });
                  });
                  that.formData.discountPriceTicketList = discountPriceTicketList;
                } else {
                  that.formData.discountPriceTicketList = [];
                }

                that.$refs['updateFormData'].validate(function (valid) {
                  if (valid) {
                    updateBairunSvcDiscountPrice(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context8.abrupt("break", 30);

              case 29:
                return _context8.abrupt("break", 30);

              case 30:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    checkParam: function checkParam() {
      if ([3].includes(this.formData.isAddTicket) && (!this.formData.discountPriceTicketList || !this.formData.discountPriceTicketList.length)) {
        this.$message({
          type: 'warning',
          message: '请选择可用优惠券'
        });
        return false;
      }

      return true;
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.onClose();
        this.getTableData();
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCheckWeekAllChange: function handleCheckWeekAllChange(val) {
      this.weekChecked = val ? this.weekOptions.map(function (w) {
        return w.value;
      }) : [];
      this.weekCheckAll = this.weekChecked.length === this.weekOptions.length;
    },
    handleCheckedWeekChange: function handleCheckedWeekChange(value) {
      this.weekCheckAll = value.length === this.weekOptions.length;

      if (this.weekCheckAll) {
        this.handleCheckWeekAllChange(true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (oil) {
        return oil.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;
    },
    handleCheckedOilCodesChange: function handleCheckedOilCodesChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleCheckAllChange(true);
      }
    },
    handleDeletes: function handleDeletes() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                ids = [];
                _this10.multipleSelection && _this10.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context9.next = 4;
                return deleteBairunSvcDiscountPriceByIds({
                  ids: ids
                });

              case 4:
                res = _context9.sent;

                if (res.code === 0) {
                  _this10.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this10.tableData.length === ids.length && _this10.page > 1) {
                    _this10.page--;
                  }

                  _this10.getTableData();
                }

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    }
  }
};